import { MOBILE_VIEW_THRESHOLD_PX, ROUTE_HOMEPAGE, ROUTE_OFFERS, ROUTE_USER_PROFILE } from '@1bill-app/constants';
import { RewardQuery } from '@1bill-app/services/reward/reward.query';
import { RewardService } from '@1bill-app/services/reward/reward.service';
import { Component, OnInit } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { map } from 'rxjs/operators';
import { trigger, transition, style, animate, state } from '@angular/animations';
import { _orderBy } from '@1bill-app/helpers/lodash.helper';
import { ApiService } from '@1bill-app/services/api/api.service';
import { Platform } from '@ionic/angular';

@Component({
  selector: 'app-points-info',
  templateUrl: './points-info.page.html',
  styleUrls: ['./points-info.page.scss'],
  animations: [
    trigger('visibilityChanged', [
      state('shown', style({ opacity: 1 })),
      state('hidden', style({ opacity: 0 })),
      transition('* => *', animate('.5s')),
    ]),
  ],
})
export class PointsInfoPage implements OnInit {
  homePage = ROUTE_USER_PROFILE;
  offersPage = ROUTE_OFFERS;
  visibility = 'hidden';
  isLoading$ = this.rewardQuery.isLoading$;
  isLoading = false;

  rewards$ = this.rewardQuery.rewards$.pipe(
    map((rewards) => rewards.filter((reward) => reward.rewardActionId !== 7)),
    map((rewards) => _orderBy(rewards, ['rewardPoints'], 'asc')),
  );
  pointsLog: any;
  error: any;
  totalEarnedPoints$ = this.rewardQuery.select('totalEarnedPoints');
  totalRedeemedPoints$ = this.rewardQuery.select('totalRedeemedPoints');
  totalPointsBalance$ = this.rewardQuery.select('totalPointsBalance');
  get isDesktopView() {
    return this.platform.width() >= MOBILE_VIEW_THRESHOLD_PX;
  }
  constructor(
    private rewardService: RewardService,
    public rewardQuery: RewardQuery,
    public logger: NGXLogger,
    public api: ApiService,
    private platform: Platform,
  ) {}

  ngOnInit() {
    this.api.pointsLog().subscribe(
      (res) => {
        this.error = null;
        this.isLoading = false;
        if (res.success) {
          this.pointsLog = res.data;
        }
      },
      (err) => {
        this.error = 'Error in loading points log.';
        this.isLoading = false;
      },
    );

    this.rewardService.getRewards().subscribe((res) => {
      this.logger.debug('rewardService', res);
    });
  }

  changevisibility() {
    this.visibility = this.visibility == 'hidden' ? 'shown' : 'hidden';
  }
}
